const MAX_SAFE_SUMMARY_LENGTH = 180;

const EMAIL_PATTERN = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/iu;
const PHONE_PATTERN = /\b(?:\+?1[\s.-]?)?(?:\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}\b/u;

const SAFE_LEGACY_SUMMARY_REPLACEMENTS = [
  [/^typing email\b/iu, "Email field edited"],
  [/^continued with .*using email\b/iu, "Continued with email"],
  [/^typing form\b/iu, "Signup form edited"],
  [/^user:/iu, "Chat message sent"],
  [/^bot:/iu, "Chat bot response sent"],
  [/^steps are not complete\b/iu, "Signup validation failed"],
  [/^asked a question\b/iu, "FAQ question submitted"],
  [/^searched for a task\b/iu, "Task search used"],
  [/^searched for\b/iu, "Location search used"],
  [/^\d+\s+helpers active at\b/iu, "Helper availability found for selected location"],
  [/^no helpers active at\b/iu, "No helper availability found for selected location"],
  [/^selected tasks\b/iu, "Selected tasks updated"],
  [/^error saving\b/iu, "Save failed"],
  [/^pricing submit failed\b/iu, "Pricing submit failed"],
  [/^pwyc submit failed\b/iu, "PWYC submit failed"],
  [/^read faq\b/iu, "FAQ expanded"],
  [/^clicked .+ button\b/iu, "Answered sentiment question"],
  [/^opened .+ task visit list\b/iu, "Opened task visit list"],
  [/^not interested saved\b/iu, "No-interest reason saved"],
  [/^referral form submitted\b/iu, "Referral form submitted"],
  [/^selected timeline\b/iu, "Selected timeline updated"],
  [/^selected pwyc rate\b/iu, "Selected PWYC rate"],
  [/^setting new membership price\b/iu, "Membership retention apply started"],
  [/^membership change\b/iu, "Membership retention price changed"],
  [/^retention apply success\b/iu, "Retention apply success"],
  [/^error saving personal details\b/iu, "Personal details save failed"],
];

const RAW_VALUE_HINTS = [
  /→/u,
  /\baddress\b/iu,
  /\bemail\b.*:/iu,
  /\bfirstName\b|\blastName\b|\bphone\b|\bpassword\b/iu,
  /\bnote\s*=/iu,
  /\bquestion:\s*\S/iu,
  /\bsearched for\b/iu,
  /\bselected pwyc rate:\s*\$/iu,
  /\btyped\b|\btyping\b/iu,
];

const hasUnsafeShape = (summary) =>
  EMAIL_PATTERN.test(summary) ||
  PHONE_PATTERN.test(summary) ||
  RAW_VALUE_HINTS.some((pattern) => pattern.test(summary));

export const sanitizeLegacySessionActivitySummary = (value) => {
  const summary = String(value ?? "").trim();
  if (!summary) return null;

  const replacement = SAFE_LEGACY_SUMMARY_REPLACEMENTS.find(([pattern]) =>
    pattern.test(summary),
  );
  if (replacement) return replacement[1];

  if (hasUnsafeShape(summary)) return null;

  return summary.slice(0, MAX_SAFE_SUMMARY_LENGTH);
};

export const _private = {
  EMAIL_PATTERN,
  PHONE_PATTERN,
  RAW_VALUE_HINTS,
  SAFE_LEGACY_SUMMARY_REPLACEMENTS,
};
